import React from 'react'

export const PostDocument = ({ src }) => {
  const isPdf = /\.pdf$/i.test(src.split(/[?#]/)[0])

  return (
    <div className="post-document">
      {isPdf && <iframe src={src} title="Dokumen" loading="lazy" />}
      <a href={src} target="_blank" rel="noreferrer" className="button">
        Buka dokumen
      </a>
    </div>
  )
}
